/* kult-gift-abo.js — Geschenk-Abo-Konfigurator (sections/kult-gift-abo.liquid, 15.10.2026).
   Liest die Produktdaten aus <script data-gift-abo-data> (Sorten mit Beuteln 250 g/500 g/1 kg je Mahlgrad,
   Preise je Geschenk-Plan aus den selling_plan_allocations) und legt die Beutel + selling_plan in den Warenkorb.
   Gebinde je Lieferung (Philip 15.10.2026): 500 g, 750 g (Standard; = 500 g + 250 g, größter Beutel zuerst) oder 1 kg.
   Versand: 1 kg je Lieferung frei; darunter frei ab der Kult-Status-Grenze (Erstbesteller = Braun) auf den
   Lieferwert nach Club-Rabatt, sonst legt der Konfigurator das Versand-Produkt (N × Satz) mit in den Warenkorb.
   Alle Zeilen tragen _kultgift_set (Gruppe, rendert snippets/kult-cart-gift-set.liquid); sichtbare Eigenschaften
   (Geschenk-Abo, Für, Von, Anlass, Geschenknachricht, Geburtstag, Geplanter Versand) nur auf der ersten Zeile. */
(function () {
  'use strict';
  var euro = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  /* zahl/einheit: Darstellung der Auswahl-Karten (große Zahl, kleine Einheit), label: Summe und Warenkorb */
  var GEBINDE = [
    { g: 500, label: '500 g', zahl: '500', einheit: 'Gramm', bags: [500] },
    { g: 750, label: '750 g', zahl: '750', einheit: 'Gramm', bags: [500, 250] },
    { g: 1000, label: '1 kg', zahl: '1', einheit: 'Kilogramm', bags: [1000] }
  ];

  function init(root) {
    var form = root.querySelector('[data-gift-abo-form]');
    var dataEl = root.querySelector('[data-gift-abo-data]');
    if (!form || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.sorten || !data.sorten.length || !data.plaene || !data.plaene.length) { root.hidden = true; return; }
    data.plaene.sort(function (a, b) { return a.n - b.n; });
    var versand = data.versand || { grenze: 0, satz: 0, freiGramm: 1000, variante: 0 };

    var sorteSel = form.querySelector('[data-ga-sorte]');
    var zubSel = form.querySelector('[data-ga-mahlgrad]');
    var planWrap = form.querySelector('[data-ga-plaene]');
    var gebindeWrap = form.querySelector('[data-ga-gebinde]');
    var summe = form.querySelector('[data-ga-summe]');
    var cta = form.querySelector('[data-ga-cta]');
    var gruss = form.querySelector('[data-ga-gruss]');
    var errEl = form.querySelector('[data-ga-error]');
    var fuer = form.querySelector('[data-ga-fuer]');
    var von = form.querySelector('[data-ga-von]');
    var anlass = form.querySelector('[data-ga-anlass]');
    var gebFeld = form.querySelector('[data-ga-geburtstag-feld]');
    var geb = form.querySelector('[data-ga-geburtstag]');
    var versandHinweis = form.querySelector('[data-ga-versand-hinweis]');

    data.sorten.forEach(function (s, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = s.titel;
      sorteSel.appendChild(o);
    });

    /* Auswahl-Karten (Design 15.10.2026): große Zahl + kleine Einheit; „alle 4 Wochen“ / „je Lieferung“ steht einmal
       in der Legende statt auf jeder Karte. Leerzeichen zwischen den Spans hält den Namen für Screenreader lesbar. */
    data.plaene.forEach(function (p, i) {
      var id = 'ga-plan-' + p.id;
      var label = document.createElement('label');
      label.className = 'kult-gift-abo__plan';
      label.innerHTML = '<input type="radio" name="ga-plan" value="' + p.id + '" id="' + id + '"' + (i === 0 ? ' checked' : '') + '>' +
        '<span class="kult-gift-abo__plan-n">' + p.n + '</span> ' +
        '<span class="kult-gift-abo__plan-sub">Lieferungen</span>';
      planWrap.appendChild(label);
    });

    /* Gebinde je Lieferung: Standard 750 g (Philip 15.10.2026), dezent mit Goldrahmen als Empfehlung; 1 kg bewusst ohne Akzent */
    if (gebindeWrap) GEBINDE.forEach(function (gb) {
      var label = document.createElement('label');
      label.className = 'kult-gift-abo__plan kult-gift-abo__gebinde' + (gb.g === 750 ? ' kult-gift-abo__gebinde--empfohlen' : '');
      label.innerHTML = '<input type="radio" name="ga-gebinde" value="' + gb.g + '"' + (gb.g === 750 ? ' checked' : '') + '>' +
        (gb.g === 750 ? '<span class="kult-gift-abo__gebinde-tag">Empfohlen</span> ' : '') +
        '<span class="kult-gift-abo__plan-n">' + gb.zahl + '</span> ' +
        '<span class="kult-gift-abo__plan-sub">' + gb.einheit + '</span>';
      gebindeWrap.appendChild(label);
    });

    function sorte() { return data.sorten[Number(sorteSel.value) || 0]; }
    function planId() {
      var r = form.querySelector('input[name="ga-plan"]:checked');
      return r ? r.value : String(data.plaene[0].id);
    }
    function plan() {
      var id = Number(planId());
      return data.plaene.filter(function (p) { return p.id === id; })[0] || data.plaene[0];
    }
    function gebinde() {
      var r = form.querySelector('input[name="ga-gebinde"]:checked');
      var g = r ? Number(r.value) : 750;
      return GEBINDE.filter(function (x) { return x.g === g; })[0] || GEBINDE[1];
    }
    function fillZub() {
      zubSel.innerHTML = '';
      sorte().varianten.forEach(function (v, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = v.zub;
        zubSel.appendChild(o);
      });
      /* Mahlgrad nach Sortenwechsel beibehalten, wenn es ihn bei der neuen Sorte gibt */
      if (zubSel.dataset.last) {
        for (var i = 0; i < sorte().varianten.length; i++) {
          if (sorte().varianten[i].zub === zubSel.dataset.last) { zubSel.value = String(i); break; }
        }
      }
    }
    function variante() { return sorte().varianten[Number(zubSel.value) || 0]; }

    /* Beutel des Gebindes mit Preisen für den gewählten Plan; null, wenn ein Beutel oder Plan-Preis fehlt. */
    function beutel() {
      var v = variante();
      var p = plan();
      if (!v || !v.groessen) return null;
      var bags = [];
      var ok = gebinde().bags.every(function (g) {
        var b = v.groessen[String(g)];
        var preis = b && b.plaene && b.plaene[String(p.id)];
        if (!b || !preis) return false;
        bags.push({ grams: g, id: b.id, listCents: b.preis, je: preis.je, gesamt: preis.gesamt });
        return true;
      });
      return ok ? bags : null;
    }
    /* Versand je Lieferung (Entscheidung Philip 15.10.2026): 1 kg frei; sonst frei ab der Status-Grenze auf den
       Lieferwert nach Club-Rabatt (Rabatt je Beutel abgerundet, wie Shopify ihn an der Kasse rechnet). */
    function versandInfo(bags) {
      var g = gebinde().g;
      var pct = Number(data.pct) || 0;
      var jeNachRabatt = bags.reduce(function (sum, b) { return sum + (b.je - Math.floor(b.je * pct / 100)); }, 0);
      var frei = (versand.freiGramm > 0 && g >= versand.freiGramm) || jeNachRabatt >= (versand.grenze || 0);
      return { frei: frei, satz: versand.satz || 0, moeglich: !!versand.variante };
    }
    function render() {
      var bags = beutel();
      var p = plan();
      if (!bags) {
        summe.innerHTML = '<span class="kult-gift-abo__summe-sub">Diese Kombination ist gerade nicht lieferbar – bitte wähle einen anderen Mahlgrad oder eine andere Größe.</span>';
        cta.disabled = true;
        return;
      }
      cta.disabled = false;
      var gesamt = bags.reduce(function (s, b) { return s + b.gesamt; }, 0);
      var je = bags.reduce(function (s, b) { return s + b.je; }, 0);
      var g = gebinde().g;
      var grund = Math.round(je * 1000 / g);
      /* Club-Preis (Kult Status, gilt ab der ersten Abo-Bestellung) zieht die Kasse als Automatikrabatt ab;
         hier als „du sparst“-Zeile ausgewiesen, der genaue Betrag steht an der Kasse. */
      var pct = Number(data.pct) || 0;
      var rabatt = Math.round(gesamt * pct / 100);
      var vi = versandInfo(bags);
      var shipCents = vi.frei || !vi.moeglich ? 0 : vi.satz * p.n;
      var versandZeile = vi.frei
        ? '<span class="kult-gift-abo__summe-sub">' + (g >= (versand.freiGramm || 1000) ? 'Versandkostenfrei (ab 1 kg je Lieferung).' : 'Versandkostenfrei dank deiner Kult-Status-Grenze.') + '</span>'
        : vi.moeglich
          ? '<span class="kult-gift-abo__summe-sub">+ Versand ' + euro(shipCents) + ' (' + p.n + ' × ' + euro(vi.satz) + '), entfällt ab 1 kg je Lieferung.</span>'
          : '';
      /* Summe (Design 15.10.2026): kleine Kicker-Zeile, Preis groß in Playfair, darunter ruhige Detailzeilen */
      summe.innerHTML =
        '<span class="kult-gift-abo__summe-label">Einmalig</span> ' +
        '<span class="kult-gift-abo__summe-total">' + euro(gesamt + shipCents) + '</span> ' +
        '<span class="kult-gift-abo__summe-details">' +
          '<span class="kult-gift-abo__summe-sub">' + p.n + ' Lieferungen à ' + gebinde().label + ', je ' + euro(je) + ' (Grundpreis ' + euro(grund) + '/kg)</span>' +
          versandZeile +
          (rabatt > 0 ? '<span class="kult-gift-abo__summe-rabatt">Im Warenkorb gehen ' + pct + ' % Club-Preis ab, du sparst ca. ' + euro(rabatt) + '.</span>' : '') +
        '</span>';
    }

    sorteSel.addEventListener('change', function () { fillZub(); render(); });
    zubSel.addEventListener('change', function () { zubSel.dataset.last = variante().zub; render(); });
    planWrap.addEventListener('change', render);
    if (gebindeWrap) gebindeWrap.addEventListener('change', render);

    /* Geburtstags-Terminierung: Versandtag so wählen, dass das Paket mit 2–3 Werktagen Lieferzeit
       rund 2 Tage vor dem Geburtstag ankommt. Versandtage Di–Sa (Montag Ruhetag, So kein Versand). */
    function versandTag(geburtstag) {
      var d = new Date(geburtstag + 'T12:00:00');
      if (isNaN(d.getTime())) return null;
      d.setDate(d.getDate() - 5); /* 2 Tage Puffer + 3 Tage Lieferzeit */
      while (d.getDay() === 0 || d.getDay() === 1) d.setDate(d.getDate() - 1);
      var heute = new Date(); heute.setHours(12, 0, 0, 0);
      if (d.getTime() <= heute.getTime()) return null; /* zu knapp: wir versenden direkt */
      return d;
    }
    function gebUpdate() {
      var zeigen = anlass && anlass.value === 'Geburtstag';
      if (gebFeld) gebFeld.hidden = !zeigen;
      if (!versandHinweis) return;
      var tag = zeigen && geb && geb.value ? versandTag(geb.value) : null;
      if (tag) {
        versandHinweis.textContent = 'Wir versenden die erste Lieferung am ' + tag.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' }) + ', damit das Paket rechtzeitig zum Geburtstag ankommt.';
        versandHinweis.hidden = false;
      } else if (zeigen && geb && geb.value) {
        versandHinweis.textContent = 'Der Geburtstag ist schon ganz nah – wir versenden die erste Lieferung direkt nach deiner Bestellung.';
        versandHinweis.hidden = false;
      } else {
        versandHinweis.hidden = true;
      }
    }
    if (anlass) anlass.addEventListener('change', gebUpdate);
    if (geb) { geb.addEventListener('change', gebUpdate); geb.min = new Date(Date.now() + 86400000).toISOString().slice(0, 10); }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (errEl) errEl.hidden = true;
      var bags = beutel();
      var p = plan();
      if (!bags) return;
      cta.disabled = true;
      cta.dataset.label = cta.dataset.label || cta.textContent;
      cta.textContent = 'Einen Moment …';
      var setId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      /* Marker auf JEDER Beutel-Zeile: versand.server.ts teilt die Prepaid-Menge je Zeile durch die Lieferzahl */
      var basis = { _kultgift_set: setId };
      basis['Geschenk-Abo'] = p.n + ' Lieferungen à ' + gebinde().label;
      var props = {};
      Object.keys(basis).forEach(function (k) { props[k] = basis[k]; });
      if (fuer && fuer.value.trim()) props['Für'] = fuer.value.trim().slice(0, 40);
      if (von && von.value.trim()) props['Von'] = von.value.trim().slice(0, 40);
      if (anlass && anlass.value && anlass.value !== 'Einfach so') props['Anlass'] = anlass.value;
      if (gruss && gruss.value.trim()) props['Geschenknachricht'] = gruss.value.trim().slice(0, 140);
      if (anlass && anlass.value === 'Geburtstag' && geb && geb.value) {
        props['Geburtstag'] = geb.value.split('-').reverse().join('.');
        var tag = versandTag(geb.value);
        if (tag) {
          props['Geplanter Versand'] = tag.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
          props['_kult_versand_ab'] = tag.getFullYear() + '-' + String(tag.getMonth() + 1).padStart(2, '0') + '-' + String(tag.getDate()).padStart(2, '0');
        }
      }
      var items = bags.map(function (b, i) {
        return { id: b.id, quantity: 1, selling_plan: Number(p.id), properties: i === 0 ? props : basis };
      });
      var vi = versandInfo(bags);
      if (!vi.frei && vi.moeglich) {
        items.push({ id: versand.variante, quantity: p.n, properties: { _kultgift_set: setId, _kultgift_versand: '1' } });
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Fehler'); });
        window.location.href = '/cart';
      }).catch(function (e) {
        cta.disabled = false;
        cta.textContent = cta.dataset.label;
        var msg = 'Das hat gerade nicht geklappt – versuch es bitte gleich noch einmal.';
        if (window.KultNotify && window.KultNotify.error) window.KultNotify.error(msg);
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
        void e;
      });
    });

    fillZub();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-gift-abo]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
